import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { TxnsLog, ViewTransactionLogs } from "../../logs/transaction-logs/view-transaction-logs";

@Component({
    selector: 'dispute-list-dialog',
    template: `
    <h1 mat-dialog-title style="font-style: bold;">{{'dispute' | translate}} {{'transaction' | translate}}  {{'details' | translate}}</h1>

    <div mat-dialog-content style="margin-top: 30px; margin-bottom: 30px; margin-left: 0px;">
      <div class="row">
        <div class="col-md-6">
          <h5><b><b>{{'transactionId' | translate}} :</b></b> {{txnsLog[0].txns_id}}</h5>
          <h5><b>{{'txnsDate' | translate}} :</b> {{txnsLog[0].txns_time|date:'dd/MM/yyyy hh:mm:ss'}}</h5>
          <h5><b>{{'txnsType' | translate}} :</b> {{txnsLog[0].txns_type}}</h5>
          <h5><b>{{'receiptNo' | translate}} :</b> {{txnsLog[0].receipt_no}}</h5>
          <h5><b>{{'custsName' | translate}} :</b> {{txnsLog[0].cust_name}}</h5>
          <h5><b>{{'custEmail' | translate}} :</b> {{txnsLog[0].cust_email}}</h5>
          <h5><b>{{'custMobile' | translate}} :</b> {{txnsLog[0].cust_mobile}}</h5>
          <h5><b>{{'custAddress' | translate}} :</b> {{txnsLog[0].cust_address}}</h5>
          <h5><b>{{'selectedPIName' | translate}} :</b> {{txnsLog[0].selected_pi_name}}</h5>
          <h5><b>{{'serviceName' | translate}} :</b> {{txnsLog[0].service_name}}</h5>
          <h5><b>{{'serviceProvider' | translate}} :</b> {{txnsLog[0].service_provider}}</h5>
          <h5><b>{{'serviceType' | translate}} :</b> {{txnsLog[0].service_type}}</h5>
          <h5><b>{{'BillFromDate' | translate}} :</b> {{txnsLog[0].bill_from_date}}</h5>
          <h5><b>{{'billToDate' | translate}} :</b> {{txnsLog[0].bill_to_date}}</h5>
          <h5><b>{{'billDueDate' | translate}} :</b> {{txnsLog[0].bill_due_date}}</h5>
          <h5><b>{{'billerName' | translate}} :</b> {{txnsLog[0].biller_name}}</h5>
          <h5><b>{{'billMobileNo' | translate}} :</b> {{txnsLog[0].bill_mobile_no}}</h5>
          <h5><b>{{'billAccno' | translate}} :</b> {{txnsLog[0].bill_accno}}</h5>
          <h5><b>{{'billAmount' | translate}} :</b> {{txnsLog[0].bill_amount}}</h5>
          <h5><b>{{'bankCharges' | translate}} :</b> {{txnsLog[0].bank_charges}}</h5>
          <h5><b>{{'ekpayFee' | translate}} :</b> {{txnsLog[0].ekpay_fee}}</h5>
          <h5><b>{{'PIDiscountAmount' | translate}} :</b> {{txnsLog[0].discount_amount}}</h5>
          <h5><b>{{'billVat' | translate}} :</b> {{txnsLog[0].bill_vat}}</h5>
        </div>
        <div class="col-md-6">
          <h5><b>{{'billRevStamp' | translate}} :</b> {{txnsLog[0].bill_rev_stamp}}</h5>
          <h5><b>{{'billLateFee' | translate}} :</b> {{txnsLog[0].bill_late_fee}}</h5>
          <h5><b>{{'billTotalAmount' | translate}} :</b> {{txnsLog[0].bill_total_amount}}</h5>
          <h5><b>{{'piTotalPaidAmount' | translate}} :</b> {{txnsLog[0].pi_total_paid_amount}}</h5>
          <h5><b>{{'billLastPaidDate' | translate}} :</b> {{txnsLog[0].bill_last_paid_date}}</h5>
          <h5><b>{{'billGenDate' | translate}} :</b> {{txnsLog[0].bill_gen_date}}</h5>
          <h5><b>{{'billNos' | translate}} :</b> {{txnsLog[0].bill_no}}</h5>
          <h5><b>{{'billType' | translate}} :</b> {{txnsLog[0].bill_type}}</h5>
          <h5><b>{{'billXchangeCode' | translate}} :</b> {{txnsLog[0].bill_xchange_code}}</h5>
          <h5><b>{{'ekpayId' | translate}} :</b> {{txnsLog[0].ekpay_id}}</h5>
          <h5><b>{{'gatewayName' | translate}} :</b> {{txnsLog[0].gateway}}</h5>
          <h5><b>{{'instrumentName' | translate}} :</b> {{txnsLog[0].isntrument_name}}</h5>
          <h5><b>{{'merchantName' | translate}} :</b> {{txnsLog[0].merchant_name}}</h5>
          <h5><b>{{'methodName' | translate}} :</b> {{txnsLog[0].method_name}}</h5>
          <h5><b>{{'payeeMode' | translate}} :</b> {{txnsLog[0].payee_mode}}</h5>
          <h5><b>{{'paymentTime' | translate}} :</b> {{txnsLog[0].payment_time}}</h5>
          <h5><b>{{'piCardNo' | translate}} :</b> {{txnsLog[0].pi_card_no}}</h5>
          <h5><b>{{'piPayAmount' | translate}} :</b> {{txnsLog[0].pi_pay_amount}}</h5>
          <h5><b>{{'piStatusMsg' | translate}} :</b> {{txnsLog[0].pi_status_msg}}</h5>
          <h5><b>{{'regEmail' | translate}} :</b> {{txnsLog[0].reg_email}}</h5>
          <h5><b>{{'regMobile' | translate}} :</b> {{txnsLog[0].reg_mobile}}</h5>
          <h5><b>{{'txnsJourneyState' | translate}} :</b> {{txnsLog[0].txns_journey_state}}</h5>
        </div>
      </div>
    </div>

    <div mat-dialog-actions>
        <button mat-button type="button" style="background-color: #FFA728;" cdkFocusInitial (click)="close()" tabindex="-1">Close</button>
    </div>
    `,
  })
  export class DisputeListDialog {

    viewTransactionLogs: ViewTransactionLogs;
    txnsLog: TxnsLog[];

    constructor(
        public dialogRef: MatDialogRef<DisputeListDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private logger: NGXLogger,
        private dialog: MatDialog,
        private router: Router) { }

    ngOnInit() {
     this.viewTransactionLogs = new ViewTransactionLogs();
     this.txnsLog = this.data.viewTransactionLogs.txns_logs;
     this.viewTransactionLogs = this.data.viewTransactionLogs;
    }

    close(): void {
      //this.logger.debug("Dispute List dialog closed");
      this.dialogRef.close(true);
    }
  }



// WEBPACK FOOTER //
// ./src/app/report/dispute-list/dispute-list-dialog.component.ts